var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpIconArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "19px",
    viewBox: "0 0 14 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vm-rangedeleted01",
    transform: "translate(-473.000000, -999.000000)",
    fill: "#4C4C4C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(473.000000, 992.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_arrow",
    transform: "translate(7.000000, 16.500000) rotate(-360.000000) translate(-7.000000, -16.500000) translate(0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,2.125 L6,17.875 C6,18.4963203 6.44771525,19 7,19 C7.55228475,19 8,18.4963203 8,17.875 L8,2.125 C8,1.50367966 7.55228475,1 7,1 C6.44771525,1 6,1.50367966 6,2.125 Z",
    id: "shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,2.41421356 L12.2928932,7.70710678 C12.6834175,8.09763107 13.3165825,8.09763107 13.7071068,7.70710678 C14.0976311,7.31658249 14.0976311,6.68341751 13.7071068,6.29289322 L7.70710678,0.292893219 C7.31658249,-0.0976310729 6.68341751,-0.0976310729 6.29289322,0.292893219 L0.292893219,6.29289322 C-0.0976310729,6.68341751 -0.0976310729,7.31658249 0.292893219,7.70710678 C0.683417511,8.09763107 1.31658249,8.09763107 1.70710678,7.70710678 L7,2.41421356 Z",
    id: "shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpIconArrow);
export default __webpack_public_path__ + "static/media/up-icon-arrow.ff444eab0a48f087ad903e39187ad06c.svg";
export { ForwardRef as ReactComponent };